"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
require("./ArcadeNavBar.css");
var games = [
    { imageUrl: "https://i.imgur.com/82ja6uf.png", url: "https://towers.degencoinflip.com", name: "Towers by Degen Coin Flip" },
    { imageUrl: "https://i.imgur.com/KOT95oO.png", url: "https://crash.degencoinflip.com", name: "Crash by Degen Coin Flip" },
    { imageUrl: "https://i.imgur.com/5OAXywp.png", url: "https://degenspin.com", name: "Degen Spin" },
    { imageUrl: "https://i.imgur.com/54wUbOq.png", url: "https://degencoindozer.com", name: "Degen Coin Dozer" },
    { imageUrl: "https://i.imgur.com/tE6QL6M.png", url: "https://degencoinflip.com", name: "Degen Coin Flip" },
];
var ArcadeNavBar = function () {
    var _a = (0, react_2.useState)(false), opened = _a[0], setOpened = _a[1];
    var _b = (0, react_2.useState)(false), notificationSeen = _b[0], setNotificationSeen = _b[1];
    // Check localStorage on component mount
    (0, react_2.useEffect)(function () {
        var hasSeenNotification = localStorage.getItem('arcadeNotificationSeen') === 'true';
        setNotificationSeen(hasSeenNotification);
    }, []);
    var handleButtonClick = function () {
        // If notification hasn't been marked as seen yet
        if (!notificationSeen) {
            // Mark notification as seen in localStorage
            localStorage.setItem('arcadeNotificationSeen', 'true');
            setNotificationSeen(true);
        }
        // Open the game menu
        setOpened(true);
    };
    return (react_1.default.createElement("div", { className: "arcade-navbar" },
        opened && react_1.default.createElement("div", { className: "card rounded-3 border", style: { width: "18rem" } },
            react_1.default.createElement("div", { className: "cursor-pointer", onClick: function () { return setOpened(false); } },
                react_1.default.createElement("img", { className: "fa-solid fa-xs fa-times", style: { position: 'absolute', top: '1rem', right: '0.69rem' }, src: "https://i.imgur.com/zPZvcBE.png" })),
            react_1.default.createElement("div", { className: "px-4 pb-4 pt-3" },
                react_1.default.createElement("h5", { className: "card-title text-center" }, "GAMES"), games === null || games === void 0 ? void 0 :
                games.map(function (game, index) { return react_1.default.createElement("a", { href: game.url, rel: "noreferrer", target: "_blank" },
                    react_1.default.createElement("img", { src: game.imageUrl, className: "games-button border rounded-3 w-100 ".concat(index < (games === null || games === void 0 ? void 0 : games.length) - 1 ? 'mb-2' : ''), alt: game.name })); }))),
        !opened &&
            react_1.default.createElement("button", { className: "btn btn-dark rounded-pill position-relative", onClick: handleButtonClick },
                react_1.default.createElement("img", { className: "fa-solid fa-xs fa-gamepad me-sm-2", src: "https://i.imgur.com/8ZVnrql.png" }),
                react_1.default.createElement("span", { className: "d-none d-sm-inline-flex" }, "Games"),
                !notificationSeen && react_1.default.createElement("span", { className: "notification-bubble" }))));
};
exports.default = ArcadeNavBar;
